import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import RecoverPasswordForm from './RecoverPasswordForm';
import LoadMask from "Utils/LoadMask/LoadMask";
import './recovery.css';

class ChangePassword extends Component {
    render() {
        const { sendRecover, loader } = this.props;
        return (
            <div className="reset-pass-container d-flex justify-content-center align-items-center">
                <div className="login-wrapper col-lg-4 col-md-12 col-12">
                    <LoadMask loading={loader} blur>
                        <RecoverPasswordForm onSubmit={sendRecover} />
                    </LoadMask>
                </div>
            </div>
        );
    }
}

export default ChangePassword;
